import React from "react";
import { DividerViewer } from "./divider-viewer.js";
const Divider = ({ node, nodeIndex, NodeViewContainer }) => {
  return /* @__PURE__ */ React.createElement(NodeViewContainer, { key: node.id, node, nodeIndex }, /* @__PURE__ */ React.createElement(DividerViewer, { node }));
};
var divider_default = Divider;
export {
  divider_default as default
};
//# sourceMappingURL=divider.js.map
